/**
 * Official logos. Web copies are scaled from the owner-supplied originals
 * (project root) without altering the artwork. The Lyster's file is trimmed
 * of empty black margin only. Never redraw or recolour these.
 */
import greyWolf320 from "../assets/brand/grey-wolf-logo-320.jpg";
import greyWolf800 from "../assets/brand/grey-wolf-logo-800.jpg";
import lysters400 from "../assets/brand/lysters-logo-400.jpg";
import lysters800 from "../assets/brand/lysters-logo-800.jpg";

export const brands = {
  greyWolf: {
    name: "The Grey Wolf",
    alt: "The Grey Wolf: Wood Fired Pizza & Grill logo",
    src: greyWolf320,
    srcSet: `${greyWolf320} 320w, ${greyWolf800} 800w`,
    width: 800,
    height: 800,
  },
  lysters: {
    name: "Lyster's Pub",
    alt: "Lyster's Pub logo",
    src: lysters400,
    srcSet: `${lysters400} 400w, ${lysters800} 800w`,
    width: 800,
    height: 410,
  },
};
